import { PersonBus } from "./PersonBus";
import { CustomerLogoBus } from "./CustomerLogoBus";
import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { EquipFieldData } from "./EquipFieldData";

export class LocationEquipmentBus extends BaseBus
{
    constructor(data: LocationEquipmentBus) {
        super(data);
        if (data && data.equipFieldData){
            this.equipFieldData = new EquipFieldData(data.equipFieldData);
        }
    }

    CID(): any {
        return this.equipmentId;
    }
    setId(id: any) {
        this.equipmentId = id;
    }
    initialize(data: LocationEquipmentBus) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: LocationEquipmentBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();
        this.equipFieldData = new EquipFieldData(data.equipFieldData);
        if (this.hasId) {
            //this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);

    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        this.updateDt = date;
        if (this.hasId) {
            this.updateUserId = userId;

        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
             this.updateUserId = userId;
        }
    }
    model: string;
    manufacturerName: string;
    manufacturerTypeName: string;
    serialNumber: string;
    notes: string;
    systemId: string;
    barcode: string;
    isActive: boolean;
    isNewForQuote: boolean;
    createdBy: string;
    creationDate: Date;
    hasImage: boolean;
    y2DCost: number;
    leakRate: number;
    emergencyCalls: number;
    equipmentId: string;
    customerId: string;
    manufacturerId: string;
    manufacturerTypeId: string;
    locationId: string;
    updateUserId: string;
    insertDt: Date
    insertUserId: string;
    updateDt: Date;
    equipFieldData: EquipFieldData;

}
